import simpleRestProvider from 'ra-data-simple-rest';
import { httpClient } from './httpClient';

const QUIKBOOKS_ENDPOINT_PAPERMAN_API_URL = process.env
  .REACT_APP_PAPERMAN_API_URL
  ? `${process.env.REACT_APP_PAPERMAN_API_URL}quickbooks`
  : '';

const quickbooksDataProvider = simpleRestProvider(
  QUIKBOOKS_ENDPOINT_PAPERMAN_API_URL,
  httpClient
);

export default quickbooksDataProvider;
